<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <template v-slot:activator="{ on }">
      <v-btn color="primary" dark v-on="on">Edit Section</v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">Edit Section</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="12" md="8">
              <v-text-field label="Section Name*" v-model="item.title" required></v-text-field>
            </v-col>
            <!-- <v-col cols="12" sm="6" md="4">
                <v-text-field label="Legal middle name" hint="example of helper text only on focus"></v-text-field>
            </v-col>-->
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Duration*"
                hint="in minutes"
                persistent-hint
                type="number"
                v-model="item.duration"
                required
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6">
              <v-select
                :items="['Multiple Choices', 'Short Question']"
                label="Question Type*"
                v-model="item.type"
                required
                disabled
              ></v-select>
            </v-col>
          </v-row>
        </v-container>
        <small>*indicates required field</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
        <v-btn color="blue darken-1" text @click="$emit('close')">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";

export default {
  name: "SectionModal",
  props: ["visible", "item"],
  data: () => ({
    dialog: false
  }),
//   computed: {
//     show: {
//       get() {
//         return this.visible;
//       },
//       set(value) {
//         if (!value) {
//           this.$emit("close");
//         }
//       }
//     }
//   }
};
</script>
